// @ts-strict-ignore
import { Vector3 } from 'three';
import { ArticleUtils } from '@article/util/article-utils';
import { Rectangle3D } from '@3d-scene/model/rectangle-3d';
import { ArticleVO } from '@article/model/vo/article.vo';
import { MathUtils } from '@3d-scene/common/util/math-utils';
import { Injectable } from '@angular/core';
import { AcceptingConnectionSortGroupHelper } from './accepting-connection-sort-group.helper';

@Injectable({ providedIn: 'root' })
export class TextureConnectionSortGroupHelper extends AcceptingConnectionSortGroupHelper {
  private readonly EPSILON: number = 5;

  protected getSortDirection(connectionRectangle: Rectangle3D, article: ArticleVO): Vector3 {
    let uDirection: Vector3 = null;
    if (ArticleUtils.isDynamicLabelingArticle(article)) {
      uDirection = super.getSortDirection(connectionRectangle, article);
    } else {
      uDirection = connectionRectangle.point1.clone().sub(connectionRectangle.point4);
      uDirection.normalize();
    }
    return uDirection;
  }

  protected isSameGeometricRectangles(previousRectangle: Rectangle3D, currentRectangle: Rectangle3D): boolean {
    return MathUtils.isEqualsVectorsByTwoAxis(previousRectangle.point1, currentRectangle.point1, this.EPSILON);
  }
}
